import { ReportRange } from '../../../../utils/report-range';
import { decimalComma, quote } from '../../reports/models/report-csv';
import { formatDateTime, formatDay, pad } from '../../reports/models/report-row.view-model';
import { STRUCTURE_LABELS } from '../../../../models/bom-structure';
import { MaterialRequirementRowDto, parentLabel, ROW_TYPE_LABELS } from './material-requirements.dto';

// The progress log's CSV dialect (0105): UTF-8 with a byte-order mark, ; between fields, CRLF
// line ends, a decimal comma in Ilość, text fields quoted
const BYTE_ORDER_MARK = '﻿';
const SEPARATOR = ';';
const LINE_END = '\r\n';

/**
 * The workbook's Zapotrzebowanie columns, in its order and words (0122) — the table's, plus Nazwa
 * zlecenia, which the table shows as the number's tooltip.
 */
export const MATERIAL_REQUIREMENTS_CSV_COLUMNS = [
  'Zlecenie',
  'Nazwa zlecenia',
  'Pozycja',
  'Do',
  'Produkt końcowy',
  'Typ',
  'Struktura',
  'Ilość',
  'Jedn.'
];

/**
 * The exported file: a stamp row, the header, then the rows — same order and same values as
 * on screen. Pure, so it can be read and tested without a browser.
 */
export function buildMaterialRequirementsCsv(rows: MaterialRequirementRowDto[], range: ReportRange, exportedAt: Date): string {
  const lines = [
    ['Wyeksportowano', formatDateTime(exportedAt), 'Zakres', range.from, range.to].join(SEPARATOR),
    MATERIAL_REQUIREMENTS_CSV_COLUMNS.map(quote).join(SEPARATOR),
    ...rows.map(row => [
      quote(row.orderNumber),
      quote(row.orderName),
      quote(row.name),
      quote(parentLabel(row)),
      quote(row.rootName),
      quote(ROW_TYPE_LABELS[row.type]),
      quote(STRUCTURE_LABELS[row.structure]),
      decimalComma(row.amount),
      quote(row.unit)
    ].join(SEPARATOR))
  ];

  return BYTE_ORDER_MARK + lines.join(LINE_END) + LINE_END;
}

/** "zapotrzebowanie_2026-10-01_2026-10-23_eksport_2026-10-23_1412.csv", as the API names the .xlsx. */
export function materialRequirementsCsvFileName(range: ReportRange, exportedAt: Date): string {
  const time = `${pad(exportedAt.getHours())}${pad(exportedAt.getMinutes())}`;

  return `zapotrzebowanie_${range.from}_${range.to}_eksport_${formatDay(exportedAt)}_${time}.csv`;
}
